module.exports = __webpack_public_path__ + "static/buildings-94a5faa3b651ba21b826798d227a05d2.svg";